import loadable from '@loadable/component';
import { WithConditionalHydration } from '../../../WithConditionalHydration';
import { conf } from '../../../../domain/services/configService';

const CookieFooterLoadable = loadable(() => import('./CookieFooter'), {
  resolveComponent: components => components.CookieFooter,
  ssr: false
});

const condition = () => ['br', 'mx'].includes(conf.siteCountryCode);

export const CookieFooter = WithConditionalHydration(
  CookieFooterLoadable,
  condition
);
